import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth lives entirely in an httpOnly `zenith_auth` cookie set by /auth/login;
// `withCredentials: true` sends it on every request. The readable
// `zenith_csrf` cookie is echoed in `X-CSRF-Token` on writes for CSRF defence.
// (Cookie migration complete — no localStorage token reads anywhere.)
// Axios base — Tally chunk / finalize can take a while on slow corporate
// networks, so give every request a generous 120s ceiling (Cloudflare's own
// idle timeout is 100s but we let axios bail slightly later for a clearer
// client-side error rather than a mystery 520).
const api = axios.create({ baseURL: API, withCredentials: true, timeout: 120000 });

const _readCookie = (name) =>
  (document.cookie.split(";").find((c) => c.trim().startsWith(name + "=")) || "").split("=")[1] || "";

export const gstPortalClient = { id: "" };

// Long gst.gov.in steps run as background jobs; poll until they finish (avoids Cloudflare's ~100 s request limit).
export async function portalJob(url, body) {
  const r = await api.post(url, body);
  if (!r.data?.job_id) return r;
  for (let i = 0; i < 400; i++) {
    await new Promise((ok) => setTimeout(ok, 3000));
    let j;
    try { j = (await api.get(`/gst-portal/jobs/${r.data.job_id}`)).data; } catch (e) { if (e?.response?.status === 404) throw e; continue; }
    if (j.status === "done") return { data: j.result };
    if (j.status === "failed") throw Object.assign(new Error("portal job failed"), { response: { status: j.code, data: { detail: j.detail } } });
  }
  throw Object.assign(new Error("timeout"), { response: { data: { detail: "gst.gov.in is taking too long — check the portal and try again" } } });
}

api.interceptors.request.use((config) => {
  if (gstPortalClient.id && (config.url || "").startsWith("/gst-portal/")) {
    config.params = { ...(config.params || {}), client_id: gstPortalClient.id };
  }
  if (["post", "put", "patch", "delete"].includes((config.method || "").toLowerCase())) {
    const csrf = _readCookie("zenith_csrf");
    if (csrf) config.headers["X-CSRF-Token"] = csrf;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      // Admin portal has its own login page — don't hijack to tenant /login.
      if (path.startsWith("/admin")) {
        if (path !== "/admin/login") window.location.href = "/admin/login";
      } else if (!path.startsWith("/login") && !path.startsWith("/signup") && !path.startsWith("/forgot-password") && !path.startsWith("/reset-password") && path !== "/") {
        localStorage.removeItem("finops_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
